// Card Product Arrows - Handles product card image navigation
document.addEventListener('DOMContentLoaded', function() {
  function initCardArrows() {
    // Find all card arrow buttons
    const cardArrows = document.querySelectorAll('.card__arrow');
    
    // For each arrow button, attach click handler if not already done
    cardArrows.forEach(arrow => {
      if (!arrow.hasAttribute('data-arrow-handler')) {
        arrow.setAttribute('data-arrow-handler', 'true');
        
        arrow.addEventListener('click', function(e) {
          // Prevent default and stop propagation to avoid card link redirect
          e.preventDefault();
          e.stopPropagation();
          
          // Find the parent card
          const card = arrow.closest('.card');
          if (!card) return;
          
          // Find media container
          const mediaContainer = card.querySelector('.media');
          if (!mediaContainer) return;
          
          // Get all media images
          const mediaImages = mediaContainer.querySelectorAll('img');
          if (mediaImages.length <= 1) return;
          
          // Find currently visible image
          let currentIndex = -1;
          let visibleImage = null;
          
          mediaImages.forEach((img, index) => {
            // Check if image is visible (not display:none and not opacity:0)
            const style = window.getComputedStyle(img);
            if (style.display !== 'none' && parseFloat(style.opacity) > 0) {
              currentIndex = index;
              visibleImage = img;
            }
          });
          
          if (currentIndex === -1) {
            // If no visible image found, show the first one
            currentIndex = 0;
            visibleImage = mediaImages[0];
          }
          
          // Calculate next/prev index
          let targetIndex;
          if (arrow.classList.contains('card__arrow--right')) {
            targetIndex = (currentIndex + 1) % mediaImages.length;
          } else {
            targetIndex = (currentIndex - 1 + mediaImages.length) % mediaImages.length;
          }
          
          // Hide current image
          if (visibleImage) {
            visibleImage.style.opacity = '0';
            setTimeout(() => {
              visibleImage.style.display = 'none';
              
              // Show target image
              const targetImage = mediaImages[targetIndex];
              targetImage.style.display = 'block';
              
              // Use RAF for smoother transitions
              requestAnimationFrame(() => {
                setTimeout(() => {
                  targetImage.style.opacity = '1';
                }, 10);
              });
            }, 150); // Short delay for smoother transition
          }
        });
      }
    });
  }
  
  // Initialize on page load
  initCardArrows();
  
  // Re-initialize on Shopify section events
  document.addEventListener('shopify:section:load', initCardArrows);
  document.addEventListener('shopify:section:select', initCardArrows);
  document.addEventListener('shopify:section:render', initCardArrows);
  
  // Apply after a short delay to catch any dynamically loaded content
  setTimeout(initCardArrows, 500);
});
